import { render, staticRenderFns } from "./MeetingReadDocuments.vue?vue&type=template&id=163fb25e"
import script from "./MeetingReadDocuments.vue?vue&type=script&lang=js"
export * from "./MeetingReadDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports